import { gql } from '@apollo/client';

/**
 * `UpdateKbWebsiteUrlInput` requires `id` plus at least one of `url` / `isActive`
 * — sending only `id` is rejected with statusCode 400.
 */
export const UPDATE_KB_WEBSITE_URL = gql`
  mutation UpdateKbWebsiteUrl($input: UpdateKbWebsiteUrlInput!) {
    updateKbWebsiteUrl(input: $input) {
      statusCode
      message
      url {
        id
        url
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;
